import { IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonModal, IonSearchbar, IonTitle, IonToolbar } from "@ionic/react";
import { radioButtonOffOutline, radioButtonOnOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import StyledButton from "../StyledButton/StyledButton";
import CustomInput from "../CustomInput/CustomInput";
import { Typography } from "@mui/joy";
import "./CustomDesplegable.css";

const CustomDesplegable = ({
  array,
  handleChange,
  mostrarTodos,
  mostrarTodosValue = -1,
  mostrarTodosLabel = "Mostrar todos",
  mostrarSearch,
  label,
  id,
  value,
  displayValue,
  isOpen,
  setIsOpen,
  placeholder,
  error,
  errorHelperText,
  helperText,
  disabled,
  variant,
}) => {
  const [texto, setTexto] = useState("");
  const [searchText, setSearchText] = useState("");
  const [opcionesValidas, setOpcionesValidas] = useState([]);
  const valorVisible = displayValue !== undefined ? displayValue : value;

  const buscarTextoOpcion = (codigoOpcion) => {
    let texto = "";
    if (mostrarTodos && codigoOpcion === mostrarTodosValue) {
      texto = mostrarTodosLabel;
    } else {
      const opcionSeleccionada = array.find(
        (item) => item.codigo === codigoOpcion
      );
      texto = opcionSeleccionada?.text || "";
    }
    setTexto(texto);
  };

  const onHandleChange = (value, textLabel) => {
    handleChange(value, id);
    buscarTextoOpcion(value);
    setIsOpen(false);
  };

  const FiltrarOpciones = (ev) => {
    const texto = ev.target.value;
    const opciones = array.filter((item) => item.text.toLowerCase().includes(texto.toLowerCase()));
    setOpcionesValidas(opciones);
    setSearchText(texto);
  };

  useEffect(() => {
    if (isOpen) {
      setOpcionesValidas(array);
    }
    buscarTextoOpcion(valorVisible);
  }, [
    array,
    isOpen,
    mostrarTodos,
    mostrarTodosLabel,
    mostrarTodosValue,
    valorVisible,
  ]);

  const useTurnosStyle = id === "Especialidad" || id === "Profesional";
  const modalClassName = useTurnosStyle ? "custom-desplegable-modal-turnos" : "custom-desplegable-modal";

  return (
    <>
      {/* <IonLabel position={"floating"}>{id}: </IonLabel>
      <IonInput onFocus={() => setIsOpen(true)} value={texto} /> */}
      <CustomInput
        // label={label}
        value={texto}
        onClick={() => setIsOpen(true)}
        type="button"
        error={error}
        placeholder={placeholder}
        errorHelperText={errorHelperText}
        helperText={helperText}
        disabled={disabled}
        variant={variant}
        startDecorator={
          <Typography variant="plain" color="neutral">
            {label}:
          </Typography>
        }
      />
      {isOpen && (
        <IonModal isOpen={isOpen} onWillDismiss={() => setIsOpen(false)} cssClass={modalClassName}>
          <IonHeader className="custom-desplegable-header">
            <IonToolbar className="custom-desplegable-toolbar">
              <StyledButton
                slot="end"
                fill="clear"
                expand="full"
                onClick={() => setIsOpen(false)}
                className="custom-desplegable-cancel-button"
              >
                Cancelar
              </StyledButton>
              <IonTitle className="custom-desplegable-title">{label}</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding custom-desplegable-content">
            {mostrarSearch && (
              <IonSearchbar
                className="custom-desplegable-searchbar"
                value={searchText}
                onIonInput={(ev) => FiltrarOpciones(ev)}
                debounce={500}
                placeholder="Buscar por nombre"
              />
            )}
            <IonList className="custom-desplegable-list">
              {mostrarTodos && (
                <IonItem
                  key={mostrarTodosValue}
                  value={mostrarTodosValue}
                  lines="none"
                  button
                  onClick={() => onHandleChange(mostrarTodosValue)}
                  className="amarillo-sol custom-desplegable-option"
                >
                  <IonLabel className="custom-desplegable-option-label">
                    <h5 className="custom-desplegable-option-title">
                      {mostrarTodosLabel.toUpperCase()}
                    </h5>
                    <p className="custom-desplegable-option-note">{undefined}</p>
                  </IonLabel>
                  <IonIcon
                    slot="start"
                    icon={
                      mostrarTodosValue !== value
                        ? radioButtonOffOutline
                        : radioButtonOnOutline
                    }
                    size="large"
                  />
                </IonItem>
              )}
              {opcionesValidas.map((item) => (
                <IonItem
                  key={item.codigo}
                  value={item.codigo}
                  lines="none"
                  button
                  onClick={() => onHandleChange(item.codigo)}
                  className="amarillo-sol custom-desplegable-option"
                >
                  {item.imageSrc && (
                    <img
                      src={item.imageSrc}
                      alt={item.text}
                      className="custom-desplegable-option-image"
                    />
                  )}
                  <IonLabel className="custom-desplegable-option-label">
                    <h5 className="custom-desplegable-option-title">{item.text}</h5>
                    <p className="custom-desplegable-option-note">{item.note}</p>
                  </IonLabel>
                  <IonIcon slot="start" icon={item.codigo !== value ? radioButtonOffOutline : radioButtonOnOutline} size="large" />
                </IonItem>
              ))}
            </IonList>
          </IonContent>
        </IonModal>
      )}
    </>
  );
};

export default CustomDesplegable;
